function Email({ className }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 32 32" className={className}>
            <g fill="none">
                <path fill="#0055ec" d="M2 10v12.5A4.5 4.5 0 0 0 6.5 27h19a4.5 4.5 0 0 0 4.5-4.5V10l-13.526 7.292a1 1 0 0 1-.948 0z" />
                <path fill="url(#SVGH8QKvcBK)" d="M2 10v12.5A4.5 4.5 0 0 0 6.5 27h19a4.5 4.5 0 0 0 4.5-4.5V10l-13.526 7.292a1 1 0 0 1-.948 0z" />
                <path fill="url(#SVGkOCYvtuq)" d="M2 10v12.5A4.5 4.5 0 0 0 6.5 27h19a4.5 4.5 0 0 0 4.5-4.5V10l-13.526 7.292a1 1 0 0 1-.948 0z" />
                <path fill="url(#SVGcCmlT1Jm)" fillOpacity="0.75" d="M2 10v12.5A4.5 4.5 0 0 0 6.5 27h19a4.5 4.5 0 0 0 4.5-4.5V10l-13.526 7.292a1 1 0 0 1-.948 0z" />
                <path fill="url(#SVGsZMU2dcf)" fillOpacity="0.7" d="M2 10v12.5A4.5 4.5 0 0 0 6.5 27h19a4.5 4.5 0 0 0 4.5-4.5V10l-13.526 7.292a1 1 0 0 1-.948 0z" />
                <path fill="url(#SVGSLELubFH)" d="M6.5 5A4.5 4.5 0 0 0 2 9.5v1.09l13.526 7.292a1 1 0 0 0 .948 0L30 10.59V9.5A4.5 4.5 0 0 0 25.5 5z" />
                <defs>
                    <linearGradient id="SVGH8QKvcBK" x1="19.555" x2="26.862" y1="13.332" y2="27.873" gradientUnits="userSpaceOnUse">
                        <stop offset=".199" stopColor="#006af0" stopOpacity="0" />
                        <stop offset=".431" stopColor="#006af0" />
                    </linearGradient>
                    <linearGradient id="SVGkOCYvtuq" x1="12" x2="4.914" y1="11.79" y2="28.328" gradientUnits="userSpaceOnUse">
                        <stop offset=".191" stopColor="#006af0" stopOpacity="0" />
                        <stop offset=".431" stopColor="#006af0" />
                    </linearGradient>
                    <linearGradient id="SVGcCmlT1Jm" x1="23.383" x2="24.532" y1="20.142" y2="28.575" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#2764e7" stopOpacity="0" />
                        <stop offset="1" stopColor="#2764e7" />
                    </linearGradient>
                    <linearGradient id="SVGsZMU2dcf" x1="20.333" x2="22.43" y1="12.088" y2="29.25" gradientUnits="userSpaceOnUse">
                        <stop offset=".533" stopColor="#ff6ce8" stopOpacity="0" />
                        <stop offset="1" stopColor="#ff6ce8" />
                    </linearGradient>
                    <linearGradient id="SVGSLELubFH" x1="10.318" x2="18.903" y1=".976" y2="23.436" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#6ce0ff" />
                        <stop offset=".462" stopColor="#29b2ff" />
                        <stop offset="1" stopColor="#4894fe" />
                    </linearGradient>
                </defs>
            </g>
        </svg>
    )
}

export default Email